import component from './status.component';
import service from './status.service';

export default angular.module('mpdx.bottom.status', [component, service]).name;
